import React from 'react';

const Table = ({ children, className = '', style = {}, ...props }) => {
  const baseStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
    ...style
  };

  return (
    <div style={{ overflowX: 'auto' }}>
      <table className={className} style={baseStyle} {...props}>
        {children}
      </table>
    </div>
  );
};

const TableHeader = ({ children, className = '', style = {} }) => (
  <thead 
    className={className}
    style={{
      backgroundColor: 'var(--color-bg-subtle)',
      ...style
    }}
  >
    {children}
  </thead>
);

const TableBody = ({ children, className = '', style = {} }) => (
  <tbody className={className} style={style}>
    {children}
  </tbody>
);

const TableRow = ({ children, className = '', style = {} }) => (
  <tr 
    className={className}
    style={{
      borderBottom: '1px solid var(--color-border)',
      ...style
    }}
  >
    {children}
  </tr>
);

const TableHead = ({ children, className = '', style = {} }) => (
  <th 
    className={className}
    style={{
      padding: '12px 16px',
      textAlign: 'left',
      fontWeight: '600',
      color: 'var(--color-text-secondary)',
      backgroundColor: 'var(--color-bg-subtle)',
      ...style
    }}
  >
    {children}
  </th>
);

const TableCell = ({ children, className = '', style = {} }) => (
  <td 
    className={className}
    style={{
      padding: '12px 16px',
      color: 'var(--color-text-muted)',
      ...style
    }}
  >
    {children}
  </td>
);

Table.Header = TableHeader;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Head = TableHead;
Table.Cell = TableCell;

export default Table;